module.exports = __webpack_public_path__ + "media/icons/alert-triangle-red-00823212.svg";